import { Controller } from '@hotwired/stimulus';
import { SocialShare } from 'common/lib/SocialShare';

export default class extends Controller {
  static targets =
  [
    'socialButton',
    'openFacebookWindow',
    'openTwitterWindow',
    'openLinkedInWindow'
  ];

  static values = {
    url: String
  }

  openFacebookWindow() {
    const inst = new SocialShare({ url: this.urlValue });
    inst.open({ target: SocialShare.TARGETS.FACEBOOK });
  }

  openTwitterWindow() {
    const inst = new SocialShare({
      message: '',
      url: this.urlValue
    });
    inst.open({ target: SocialShare.TARGETS.TWITTER });
  }

  openLinkedInWindow() {
    const inst = new SocialShare({ url: this.urlValue });
    inst.open({ target: SocialShare.TARGETS.LINKEDIN });
  }
}
